// "Put VegaPart on your phone": a one-time card on phones that are not running the installed app yet
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { Icon } from './icons';

type PromptEvent = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: string }> };
const KEY = 'vp-install-dismissed';
let deferred: PromptEvent | null = null;
if (typeof window !== 'undefined') window.addEventListener('beforeinstallprompt', e => { e.preventDefault(); deferred = e as PromptEvent; });

const standalone = () => window.matchMedia?.('(display-mode: standalone)').matches || (navigator as { standalone?: boolean }).standalone === true
  || /VegaPartApp/.test(navigator.userAgent);
const ios = () => /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
const phone = () => window.matchMedia?.('(max-width: 900px)').matches;

export function InstallCard() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [canPrompt, setCanPrompt] = useState(!!deferred);
  const home = useLocation().pathname === '/';
  useEffect(() => {
    let off = false;
    try { off = localStorage.getItem(KEY) === '1'; } catch { /* private mode */ }
    setShow(!off && !standalone() && phone());
    const on = () => setCanPrompt(true);
    window.addEventListener('beforeinstallprompt', on);
    return () => window.removeEventListener('beforeinstallprompt', on);
  }, []);
  if (!show || !home) return null;
  const close = () => { setShow(false); try { localStorage.setItem(KEY, '1'); } catch { /* private mode */ } };
  const install = async () => { if (!deferred) return; await deferred.prompt(); const r = await deferred.userChoice; deferred = null; if (r.outcome === 'accepted') close(); };
  return (
    <div className="install-card no-print">
      <img src="/icon-192.png" alt="" width="44" height="44" />
      <div className="install-text">
        <b>{t('install.title')}</b>
        <span>{canPrompt ? t('install.android') : ios() ? t('install.ios') : t('install.other')}</span>
      </div>
      {canPrompt && <button type="button" className="btn primary" onClick={() => void install()}>{t('install.button')}</button>}
      <button type="button" className="install-x" onClick={close} aria-label={t('common.close')}><Icon name="plus" size={20} /></button>
    </div>
  );
}
